import Button from "@/components/bricks/button/Button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "../../select/Select";
import { StickyFooter } from "../../stickyFooter/modalStickyFooter";
import {
  OpretKursusLinjeStep1Formik,
  OpretKursusLinjeStep2Formik,
} from "./useOpretKursusLinje";
import { FormikProps } from "formik";
import { TextInputFormik } from "../../formcontrols/InputItem";
import ValidationErrorMessage from "../../formcontrols/ValidationErrorMessage";
import { FormikDatePicker } from "../../formcontrols/DatePicker";
import { FMUKURSUS_KATEGORIER } from "../../../constants/common";
import { useHotels } from "../../../hooks/useQueries";
import AutoCompleteFormControl from "../../formcontrols/AutoCompleteFormControl";
import FormikTimePicker from "../../formcontrols/TimePicker";
import IsRequired from "../../formcontrols/common/IsRequired";

export default function OpretKursusLinjeStep1(props: {
  setModalOpen: (open: boolean) => void;
  step1: FormikProps<OpretKursusLinjeStep1Formik>;
  step2: FormikProps<OpretKursusLinjeStep2Formik>;
  opretKursusQueryisLoading: boolean;
}) {
  const { step1, setModalOpen, step2, opretKursusQueryisLoading } = props;
  const { values } = step1;
  const { kursusOrLinje, kursustype } = values;

  return (
    <>
      <form autoComplete="off" onSubmit={step1.handleSubmit}>
        <fieldset disabled={opretKursusQueryisLoading}>
          <div className="c-item-list c-modal-container-inner">
            <h3 className="mb-n2 flex-100">Opret</h3>
            <div className="flex-100 flex-row">
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="opretKursusLinje"
                  id="opretKursus"
                  checked={kursusOrLinje === "kursus"}
                  onChange={(e) => {
                    if (e.target.checked) {
                      step1.setFieldValue("kursusOrLinje", "kursus");
                    }
                  }}
                />
                <label className="form-check-label" htmlFor="opretKursus">
                  Kursus
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="opretKursusLinje"
                  id="opretLinje"
                  checked={kursusOrLinje === "linje"}
                  onChange={(e) => {
                    if (e.target.checked) {
                      step1.setFieldValue("kursusOrLinje", "linje");
                    }
                  }}
                />
                <label className="form-check-label" htmlFor="opretLinje">
                  Linje
                </label>
              </div>
            </div>
            {kursusOrLinje === "kursus" && (
              <>
                <h3 className="flex-100 mb-n2 mt-1">Kursus</h3>
                <div>
                  <TextInputFormik
                    formik={step1}
                    config={{
                      component: "textinput",
                      id: "navn",
                      label: "Navn",
                      isRequired: true,
                      initialValue: "",
                    }}
                  />
                </div>
                <div>
                  <label className="form-label">
                    Type <IsRequired />
                  </label>
                  <Select
                    value={kursustype?.toString() ?? ""}
                    onValueChange={(val) =>
                      step1.setFieldValue("kursustype", parseInt(val))
                    }
                  >
                    <SelectTrigger
                      aria-label="Vælg type"
                      placeholder="Vælg"
                      className={
                        step1.touched.kursustype && step1.errors.kursustype
                          ? "is-invalid"
                          : ""
                      }
                    />
                    <SelectContent>
                      {FMUKURSUS_KATEGORIER.map((category) => (
                        <SelectItem
                          key={category.nr}
                          value={category.nr.toString()}
                        >
                          {category.navn}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  <ValidationErrorMessage
                    touched={step1.touched.kursustype}
                    errorMessage={step1.errors.kursustype}
                  />
                </div>
                <div className="flex-100">
                  <HotelFormControl step1={step1} />
                </div>
                <div>
                  <FormikDatePicker
                    formik={step1}
                    config={{
                      initialValue: "",
                      component: "datepicker",
                      id: "fraDato",
                      label: "Startdato",
                      isRequired: true,
                    }}
                  />
                </div>
                <div>
                  <FormikTimePicker
                    formik={step1}
                    placeholder="--:--"
                    config={{
                      placeholder: "--:--",
                      component: "timepicker",
                      id: "fraKlDag",
                      label: "Starttidspunkt",
                      isRequired: true,
                    }}
                  />
                </div>
                <div>
                  <FormikDatePicker
                    formik={step1}
                    config={{
                      initialValue: "",
                      component: "datepicker",
                      id: "tilDato",
                      label: "Slutdato",
                      isRequired: true,
                    }}
                  />
                </div>
                <div>
                  <FormikTimePicker
                    formik={step1}
                    placeholder="--:--"
                    config={{
                      placeholder: "--:--",
                      component: "timepicker",
                      id: "tilKlDag",
                      label: "Sluttidspunkt",
                      isRequired: true,
                    }}
                  />
                </div>
              </>
            )}
            {kursusOrLinje === "linje" && (
              <>
                <h3 className="flex-100 mb-n2 mt-1">Linje</h3>
                <div className="flex-100">
                  <TextInputFormik
                    formik={step1}
                    config={{
                      component: "textinput",
                      id: "navn",
                      label: "Navn",
                      isRequired: true,
                      initialValue: "",
                    }}
                  />
                </div>
                <div className="flex-100">
                  <HotelFormControl step1={step1} />
                </div>
              </>
            )}
          </div>
          <StickyFooter>
            <Button
              color="secondary"
              onClick={() => {
                setModalOpen(false);
                step1.resetForm();
                step2.resetForm();
              }}
            >
              Annuller
            </Button>

            <Button type="submit" color="primary">
              Næste
            </Button>
          </StickyFooter>
        </fieldset>
      </form>
    </>
  );
}

function HotelFormControl(props: { step1: any }) {
  const { step1 } = props;
  const { hotels, getHotelsLoading, getHotelsError, getHotelById } =
    useHotels();
  return (
    <>
      <label className="form-label" htmlFor={"hotelId"}>
        Hotel <IsRequired />
      </label>
      <AutoCompleteFormControl
        className={
          step1.touched.hotelId && step1.errors.hotelId ? "is-invalid" : ""
        }
        onChange={(e) => {
          const selectedHotel = getHotelById(e);
          if (selectedHotel) {
            step1.setFieldValue("hotelId", selectedHotel.id);
          } else {
            step1.setFieldValue("hotelId", undefined);
          }
        }}
        queryValues={{
          data: hotels
            ? hotels.map((h) => {
                return {
                  ...h,
                  navn: h.navn1,
                };
              })
            : undefined,
          error: getHotelsError,
          isPending: getHotelsLoading,
        }}
        value={step1.values.hotelId}
      />
      <ValidationErrorMessage
        touched={step1.touched.hotelId}
        errorMessage={step1.errors.hotelId}
      />
    </>
  );
}
